import CheckIcon from "@mui/icons-material/Check";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function StateCom(props) {
  const [selectState, setSelectState] = useState();
  const [stateCounts, setStateCounts] = useState();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    setSelectState(props.orderState);
  }, [props.orderState]);

  useEffect(() => {
    setStateCounts(props.stateCounts);
  }, [props.stateCounts]);

  const [state, setState] = useState([
    {
      id: 7,
      name: "همه",
      color: "#bababa",
      borderColor: "#bababa",
    },
    {
      id: 1,
      name: "نامشخص",
      color: "#fff",
      borderColor: "#bababa",
    },
    {
      id: 6,
      name: "حسابرسی",
      color: "#FFC36E",
      borderColor: "#FFC36E",
    },
    {
      id: 4,
      name: "بررسی",
      color: "#ffe7b4",
      borderColor: "#ffe7b4",
    },
    {
      id: 5,
      name: "ارسال",
      color: "#eacdff",
      borderColor: "#eacdff",
    },
    {
      id: 2,
      name: "نهایی",
      color: "#bceda394",
      borderColor: "#bceda394",
    },
    {
      id: 3,
      name: "عدم تایید",
      color: "#ff9393c9",
      borderColor: "#ff9393c9",
    },
    {
      id: 0,
      name: "آنلاین ناموفق",
      color: "#ffdbdb",
      borderColor: "#ffdbdb",
    },
    {
      id: 8,
      name: "موفق",
      color: "#82ce7cad",
      borderColor: "#82ce7cad",
    },
  ]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: isSmall ? "flex-start" : "center",
        flexDirection: isSmall ? "column" : "row",
        width: "100%",
      }}
    >
      <Typography variant="subtitle2">وضعیت :</Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 1,
        }}
      >
        {props.stateCounts &&
          state.map((model, i) => {
            return (
              <Box
                onClick={() => {
                  props.setOrderState(model.id);
                  props.setRefresh(true);
                  props.setSearch("");
                  props.setSearchSend("");
                  props.setOrderFilter(0);
                  return navigate(`/orders?state=${model.id}`);
                }}
                color="primary"
                sx={{
                  py: 0.2,
                  px: 1,
                  display: "flex",
                  // width: isSmall && "30%",
                  alignItems: "center",
                  justifyContent: "space-around",
                  backgroundColor: model.color,
                  borderRadius: "7px",
                  border: "1px",
                  borderStyle: "solid",
                  borderColor: model.borderColor,
                  cursor: "pointer",
                }}
                key={i}
              >
                {searchParams && model.id == searchParams.get("state") ? (
                  <CheckIcon color="#fff" fontSize="small" />
                ) : (
                  <CheckIcon sx={{ display: "none" }} />
                )}
                <Typography
                  variant="caption"
                  sx={{
                    mr: 0.5,
                    color: "black",
                  }}
                >
                  {model.name}
                </Typography>
                <Box
                  sx={{
                    bgcolor: "#fff",
                    color: "black",
                    borderRadius: "7px",
                    direction: "rtl",
                    px: 1,
                    // width: isSmall ? "12vw" : "3vw",
                    textAlign: "center",
                    border: model.borderColor ? "1px" : "0px",
                    borderStyle: "solid",
                    borderColor: model.borderColor,
                  }}
                >
                  <Typography
                    // sx={{ fontSize: isSmall ? "2.5vw" : ".7vw" }}
                    variant="caption"
                  >
                    {stateCounts
                      ? stateCounts.find((m) => m.stateID == model.id)?.count
                      : 0}
                  </Typography>
                </Box>
              </Box>
            );
          })}
      </Box>
    </Box>
  );
}
